import { JobReport } from 'types'
import { ApiFactory } from 'apiFactory'

/**
 * Polls the job status for email trigger operations (support requests, name changes, etc.)
 * @param jobId - The job ID to poll
 * @param maxAttempts - Maximum number of polling attempts (default: 10)
 * @param delayMs - Delay between polling attempts in milliseconds (default: 1000)
 * @returns Promise<JobReport> - The completed job report
 * @throws Error if polling fails or times out
 */
export const pollEmailTriggerStatus = async (
  jobId: number,
  maxAttempts: number = 10,
  delayMs: number = 1000,
): Promise<JobReport> => {
  const token = localStorage.getItem('eltoro_token')
  const { notificationsAPI } = ApiFactory(token)

  if (!notificationsAPI) {
    throw new Error('Failed to initialize notifications API')
  }
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      const jobReport = await notificationsAPI.advertisingPlatformServiceGetRouteJobReport(
        jobId,
      )

      // If job is complete, return the report
      if (jobReport.status === 'complete') {
        return jobReport as JobReport
      }

      // If not complete and we have more attempts, wait and try again
      if (attempt < maxAttempts) {
        await new Promise((resolve) => setTimeout(resolve, delayMs))
      }
    } catch (error) {
      if (attempt === maxAttempts) {
        throw error
      }
      await new Promise((resolve) => setTimeout(resolve, delayMs))
    }
  }

  throw new Error(
    `Job ${jobId} did not complete within ${maxAttempts} attempts`,
  )
}
